import styled from 'styled-components';

export const SearchResultItem= styled.div`
  width: 5.5rem;
  height: 1.5rem;
  margin-left: 1rem;
  display: flex;
  align-items: center;
`;